import React, { useState } from 'react';
import { Form, Button, Container, Card, Row, Col, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { addTender } from '../../services/tenderService';
import { message } from 'antd'; // Add antd message
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import mammoth from 'mammoth';

const TenderForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const statusOptions = [
    { id: '8AF7F84A-B3CC-4208-A030-32E3E9891C28', label: 'Sonuçlandı' },
    { id: '8F9F7E16-17E1-43B4-988B-76B6395E03ED', label: 'Sonuçlanmadı' },
    { id: '12D309D8-1F87-4A64-A3D7-C8DEDAB27978', label: 'İptal Edildi' }
  ];

  const [formData, setFormData] = useState({
    date: '',
    department: '',
    header: '',
    detail: '',
    statusId: '8F9F7E16-17E1-43B4-988B-76B6395E03ED', // Varsayılan "Sonuçlanmadı" durumu
    kikNo: '',
    address: 'İSKENDERUN BELEDİYESİ BRİFİNG SALONU KAT:3 ( YENİŞEHİR MAHALLESİ M. FEVZİ ÇAKMAK CAD. NO:11 İSKENDERUN / HATAY )',
    phone: '',
    email: 'ihale@iskenderun.bel.tr',
    subject: '',
    placeOfDelivery: '',
    dateOfDelivery: '',
    tendarOrganizationAddress: '',
    detailDescription: '',
    deadline: '',
    file: null,
    fileUrl: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file size (10MB)
      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        message.warning('Dosya boyutu 10MB\'dan büyük olamaz');
        e.target.value = ''; // Clear the file input
        return;
      }

      // Validate file type
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedTypes.includes(file.type)) {
        message.warning('Sadece PDF ve Word dosyaları kabul edilmektedir');
        e.target.value = ''; // Clear the file input
        return;
      }

      // Eğer .docx dosyası ise içeriğini Detay alanına aktar
      const isDocx = file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                    file.name.toLowerCase().endsWith('.docx');
      
      if (isDocx) {
        try {
          setLoading(true);
          const arrayBuffer = await file.arrayBuffer();
          const result = await mammoth.convertToHtml({ arrayBuffer: arrayBuffer });
          
          // Detay alanına HTML içeriğini ekle
          setFormData(prevState => ({
            ...prevState,
            file: file,
            detail: result.value // HTML içeriği
          }));
          
          message.success('Word dosyası içeriği Detay alanına aktarıldı!');
        } catch (error) {
          console.error('Word dosyası okuma hatası:', error);
          message.warning('Word dosyası okunurken bir hata oluştu. Dosya yine de yüklenecek.');
          
          setFormData(prevState => ({
            ...prevState,
            file: file
          }));
        } finally {
          setLoading(false);
        }
      } else {
        setFormData(prevState => ({
          ...prevState,
          file: file
        }));
      }
    } else {
      setFormData(prevState => ({
        ...prevState,
        file: null
      }));
    }
  };

  // Removed convertToBase64 as it's now handled in the service

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await addTender(formData);
      if (response.isSuccess) {
        message.success('İhale başarıyla eklendi!');
        
        setTimeout(() => {
          navigate('/tenders');
        }, 1500);
      } else {
        message.error(response.resultMessage || 'İhale eklenirken bir hata oluştu.');
      }
    } catch (error) {
      console.error('Error adding tender:', error);
      const errorMessage = error.response?.data?.message || 'İhale eklenirken bir hata oluştu.';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>


      <Card className="mt-4 mb-4">
        <Card.Body>
          <h2 className="mb-4">Yeni İhale Ekle</h2>
          
          <Alert variant="warning" className="mb-4">
            <Alert.Heading>Önemli Uyarı!</Alert.Heading>
            <p className="mb-0">
              Tüm alanların eksiksiz doldurulması gerekmektedir. Lütfen tüm bilgileri eksiksiz giriniz.
            </p>
          </Alert>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>İhale Başlığı</Form.Label>
                  <Form.Control
                    type="text"
                    name="header"
                    value={formData.header}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Birim</Form.Label>
                  <Form.Control
                    type="text"
                    name="department"
                    value={formData.department}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>İhale Tarihi</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>E-posta</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Adres</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>İhale Durumu</Form.Label>
                  <Form.Select
                    name="statusId"
                    value={formData.statusId}
                    onChange={handleChange}
                  >
                    {statusOptions.map(option => (
                      <option key={option.id} value={option.id}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>İhale Dosyası</Form.Label>
                  <Form.Control
                    type="file"
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Detay</Form.Label>
                  <ReactQuill
                    theme="snow"
                    value={formData.detail}
                    onChange={(value) => {
                      setFormData(prevState => ({
                        ...prevState,
                        detail: value
                      }));
                    }}
                    modules={{
                      toolbar: [
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                        [{ 'font': [] }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'script': 'sub'}, { 'script': 'super' }],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }],
                        [{ 'align': [] }],
                        ['link', 'image', 'video'],
                        ['code-block'],
                        ['clean']
                      ]
                    }}
                    formats={[
                      'header', 'font', 'size',
                      'bold', 'italic', 'underline', 'strike', 'blockquote',
                      'color', 'background',
                      'script',
                      'list', 'bullet', 'indent',
                      'align',
                      'link', 'image', 'video',
                      'code-block'
                    ]}
                    style={{ height: '400px', marginBottom: '50px' }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end gap-2 mt-3">
              <Button 
                variant="secondary" 
                onClick={() => navigate('/tenders')}
                disabled={loading}
              >
                İptal
              </Button>
              <Button 
                variant="primary" 
                type="submit"
                disabled={loading}
              >
                {loading ? 'Kaydediliyor...' : 'Kaydet'}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TenderForm;
